export const environment = {
  hmr: false,
  env: window['env']['env'] || 'hom',
  production: window['env']['env'] === 'prd',
  // baseUrl:  window['env']['baseUrl'] || 'https://cnes-cloud-bff-hom.saude.gov.br/cnes-bff/v1',
  // baseUrl:  window['env']['baseUrl'] || 'https://cnes-backend-hom.saude.gov.br',
  // urlBaseNova: window['env']['urlBaseNova'] || 'https://cnes-backend-hom.saude.gov.br',
  urlBaseNova: window['env']['urlBaseNova'] || 'http://localhost:9091',
  
  urlBaseCoorporativo: window['env']['urlBaseCoorporativo'] || 'https://servicoshm.saude.gov.br/corporativo/v2r0',
  urlBaseNotificacao: window['env']['urlBaseNotificacao'] || 'https://notificacao-api-hom.saude.gov.br/notificacao',
  baseUrlScpa: window['env']['baseUrlScpa'] || 'https://autorizador-hom.saude.gov.br',
  // baseUrlScpa: window['env']['baseUrlScpa'] || 'https://autorizador.hom.saude.gov.br',
  baseUrlFront: window['env']['baseUrlFront'] || 'http://localhost:8100',
  sistemaScpa: window['env']['sistemaScpa'] || 'CNES',
};
